import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a9b391886bf03001434d12c_1788776962973_06f18991/y77poultry/src/app/suppliers/[id]/page.tsx");
